module.exports = __webpack_public_path__ + "assets/images/como_jogar_7f732b176a57d303dbdc59205bb5a6c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-seven/como_jogar.png
// module id = 234
// module chunks = 0